import Connection from './connection';

const con = new Connection();

export default con;
